var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "border",
      attrs: {
        visible: _vm.isVisible,
        title: _vm.titulo,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": _vm.showClose,
        width: _vm.widthDialog,
        "before-close": _vm.beforeClose
      }
    },
    [
      _vm._t("default"),
      _c("div", { staticClass: "buttons" }, [
        _c(
          "div",
          { staticClass: "btn" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "default" },
                on: {
                  click: function($event) {
                    return _vm.$emit("cancelar")
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fas fa-times" }),
                  _c("b", [_vm._v("  " + _vm._s(_vm.tituloBtnCancelar))])
                ])
              ]
            ),
            _c(
              "el-button",
              {
                attrs: { disabled: _vm.disableConfirmar, type: "default" },
                on: {
                  click: function($event) {
                    return _vm.$emit("confirmar")
                  }
                }
              },
              [
                _c("span", { staticClass: "end" }, [
                  _c("i", { staticClass: "fas fa-check" }),
                  _c("b", [_vm._v("  " + _vm._s(_vm.tituloBtnConfirmar))])
                ])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c2a1b6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c2a1b6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDialog.vue
// module id = null
// module chunks = 